import React from "react";
import { every, some } from "lodash";
import { useSearchParams } from "next/navigation";

export function useResetSearchHook({ callback }: { callback: () => void }) {
  const runs = React.useRef<number>(0);
  const searchParams = useSearchParams();
  const params = {
    tag: searchParams?.get("tag"),
    query: searchParams?.get("q"),
    category: searchParams?.get("category"),
    page: searchParams?.get("page"),
  };

  const paramsEmpty = every(Object.values(params).map((value) => !value));
  React.useEffect(() => {
    if (paramsEmpty && runs.current > 0) {
      callback();
    }
  }, [callback, paramsEmpty]);

  const search = some(Object.values(params));
  React.useEffect(() => {
    if (search) {
      runs.current += 1;
    }
  }, [search]);
}
